$(document).ready(function () {
    "use strict";
    var _rtl = false
    if ($("body").css("direction") == "rtl") {
        _rtl = true;
    }

    // Add sticky navbar +  // Adjust Same Height for Dropdown
    if (($(window).width()) > 992) {
        var dropdown2 = $('.dropdown .dropdown-menu li.dropdown-submenu .dropdown-menu');
        var dropdownHeight = 'auto';
        var dropdownMax = 0;
        $('li.dropdown').hover(function () {
            if ($(this).children().children().hasClass('dropdown-submenu')) {
                var dropdown1 = ($(this).children('ul').height());
                $(dropdown2).each(function () {
                    var x = $(this).height()
                    if(dropdownMax < x){
                        dropdownMax = x
                    }
                });

                if (dropdown1 > dropdownMax) {
                    dropdownHeight = dropdown1;
                }
                else {
                    dropdownHeight = dropdownMax;
                }

                $('.dropdown-submenu .dropdown-menu').height(dropdownHeight);
                $('.dropdown .dropdown-menu').height(dropdownHeight);
            } else {
                $('.dropdown .dropdown-menu').css('height', 'auto');
            }
        })
    }

    var heightThePage = $('body').height()
    $(window).scroll(function () {
        var scroll = $(this).scrollTop()
        if (scroll > 240) {
            $('.site-header').addClass('sticky')
            if (heightThePage > 2400) {
                $('.sidebar').addClass('sticky-sidebar')
            }
        }
        else {
            $('.site-header').removeClass('sticky')
            $('.sidebar').removeClass('sticky-sidebar')
        }
    })

    // Add sticky navbar icon when scroll
    if (($(window).width()) < 992) {
        $('.navbar-nav li.dropdown a i').click(function () {
            $(this).parent().siblings('ul').fadeToggle(200).parent().siblings().children('ul').hide().siblings('a').children('i').removeClass('rotate')
            $(this).toggleClass('rotate')
        });

        $('#header .site-header .language .btn').click(function () {
            $('#header .site-header .navbar .menu-container .navbar-collapse').animate({scrollTop: 9999}, 1000)
        });

        // open navbar dropdown item
        $('#header .site-header .navbar .menu-container .navbar-collapse .navbar-nav .dropdown .fa-chevron-right').on('click', function (e) {
            var x = $(this).parent().siblings()
            if(x.length > 0){
                e.stopPropagation()
                e.preventDefault()
            }
        });
    }

    // open navbar in mobile
    $('#header .site-header .navbar .toggler').on('click', function () {
        $(this).toggleClass('active')
        $('#header .site-header .navbar .menu-container').slideToggle()
    });

    // Doctors Slider
    $('.doctors-carousel').owlCarousel({
        loop:true,
        dots: false,
        margin:80,
        items:3,
        center:true,
        nav:true,
        navText: ['<svg xmlns="http://www.w3.org/2000/svg" width="59.384" height="58.97" viewBox="0 0 59.384 58.97"><defs><style>.a{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:2px;}</style></defs><g transform="translate(-1193.936 -511.98)"><g transform="translate(1230.523 562.07) rotate(-135)"><path class="a" d="M39.735-.549-.549,39.734" transform="translate(0 -10.045)"/><path class="a" d="M28.9,28.664l-29.451.787L.238,0" transform="translate(0 0.238)"/></g></g></svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="59.384" height="58.97" viewBox="0 0 59.384 58.97"><defs><style>.a{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:2px;}</style></defs><g transform="translate(-1193.936 -511.98)"><g transform="translate(1230.523 562.07) rotate(-135)"><path class="a" d="M39.735-.549-.549,39.734" transform="translate(0 -10.045)"/><path class="a" d="M28.9,28.664l-29.451.787L.238,0" transform="translate(0 0.238)"/></g></g></svg>'],
        navClass: ['owl-prev', 'owl-next'],
        rtl: _rtl,
        responsive: {
            0: {
                margin:0,
            },
            576: {
                margin:40,
            },
            992: {
                margin:80,
            }
        },
    })

    // Clients Slider
    $('.clients-carousel').owlCarousel({
        loop:true,
        dots: true,
        nav:true,
        navText: ['<svg xmlns="http://www.w3.org/2000/svg" width="59.384" height="58.97" viewBox="0 0 59.384 58.97"><defs><style>.a{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:2px;}</style></defs><g transform="translate(-1193.936 -511.98)"><g transform="translate(1230.523 562.07) rotate(-135)"><path class="a" d="M39.735-.549-.549,39.734" transform="translate(0 -10.045)"/><path class="a" d="M28.9,28.664l-29.451.787L.238,0" transform="translate(0 0.238)"/></g></g></svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="59.384" height="58.97" viewBox="0 0 59.384 58.97"><defs><style>.a{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:2px;}</style></defs><g transform="translate(-1193.936 -511.98)"><g transform="translate(1230.523 562.07) rotate(-135)"><path class="a" d="M39.735-.549-.549,39.734" transform="translate(0 -10.045)"/><path class="a" d="M28.9,28.664l-29.451.787L.238,0" transform="translate(0 0.238)"/></g></g></svg>'],
        navClass: ['owl-prev', 'owl-next'],
        navContainer : '.clients-nav-container' ,
        dotsContainer : '.clients-dots-container' ,
        rtl: _rtl,
        responsive: {
            0: {
                items:1,
                margin:5,
            },
            768: {
                items:2.75,
                margin:15,
            }
        },
    })

    // articles Slider
    $('.articles-carousel').owlCarousel({
        loop:true,
        dots: true,
        nav:true,
        navText: ['<svg xmlns="http://www.w3.org/2000/svg" width="59.384" height="58.97" viewBox="0 0 59.384 58.97"><defs><style>.a{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:2px;}</style></defs><g transform="translate(-1193.936 -511.98)"><g transform="translate(1230.523 562.07) rotate(-135)"><path class="a" d="M39.735-.549-.549,39.734" transform="translate(0 -10.045)"/><path class="a" d="M28.9,28.664l-29.451.787L.238,0" transform="translate(0 0.238)"/></g></g></svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="59.384" height="58.97" viewBox="0 0 59.384 58.97"><defs><style>.a{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:2px;}</style></defs><g transform="translate(-1193.936 -511.98)"><g transform="translate(1230.523 562.07) rotate(-135)"><path class="a" d="M39.735-.549-.549,39.734" transform="translate(0 -10.045)"/><path class="a" d="M28.9,28.664l-29.451.787L.238,0" transform="translate(0 0.238)"/></g></g></svg>'],
        navClass: ['owl-prev', 'owl-next'],
        navContainer : '.articles-nav-container' ,
        dotsContainer : '.articles-dots-container' ,
        startPosition: 4,
        rtl: _rtl,
        responsive: {
            0: {
                autoWidth:true,
                margin:5,
            },
            576: {
                autoWidth:false,
                margin:20,
                items:2,
            },
            992: {
                autoWidth:false,
                margin:20,
                items:3,
            }
        },
    })

    // Sidebar Client Slider
    $('.side-client-carousel').owlCarousel({
        loop:true,
        dots: true,
        nav:true,
        lazyLoad: true,
        navText: ['<svg xmlns="http://www.w3.org/2000/svg" width="59.384" height="58.97" viewBox="0 0 59.384 58.97"><defs><style>.a{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:2px;}</style></defs><g transform="translate(-1193.936 -511.98)"><g transform="translate(1230.523 562.07) rotate(-135)"><path class="a" d="M39.735-.549-.549,39.734" transform="translate(0 -10.045)"/><path class="a" d="M28.9,28.664l-29.451.787L.238,0" transform="translate(0 0.238)"/></g></g></svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="59.384" height="58.97" viewBox="0 0 59.384 58.97"><defs><style>.a{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:2px;}</style></defs><g transform="translate(-1193.936 -511.98)"><g transform="translate(1230.523 562.07) rotate(-135)"><path class="a" d="M39.735-.549-.549,39.734" transform="translate(0 -10.045)"/><path class="a" d="M28.9,28.664l-29.451.787L.238,0" transform="translate(0 0.238)"/></g></g></svg>'],
        navClass: ['owl-prev', 'owl-next'],
        navContainer : '.side-client-nav-carousel' ,
        dotsContainer : '.side-client-dots-carousel' ,
        rtl: _rtl,
        items:1,
    })

    // Sidebar gallery Slider
    $('.side-gallery-carousel').owlCarousel({
        loop:true,
        dots: true,
        dotsEach: 3,
        nav:true,
        lazyLoad: true,
        navText: ['<svg xmlns="http://www.w3.org/2000/svg" width="59.384" height="58.97" viewBox="0 0 59.384 58.97"><defs><style>.a{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:2px;}</style></defs><g transform="translate(-1193.936 -511.98)"><g transform="translate(1230.523 562.07) rotate(-135)"><path class="a" d="M39.735-.549-.549,39.734" transform="translate(0 -10.045)"/><path class="a" d="M28.9,28.664l-29.451.787L.238,0" transform="translate(0 0.238)"/></g></g></svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="59.384" height="58.97" viewBox="0 0 59.384 58.97"><defs><style>.a{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:2px;}</style></defs><g transform="translate(-1193.936 -511.98)"><g transform="translate(1230.523 562.07) rotate(-135)"><path class="a" d="M39.735-.549-.549,39.734" transform="translate(0 -10.045)"/><path class="a" d="M28.9,28.664l-29.451.787L.238,0" transform="translate(0 0.238)"/></g></g></svg>'],
        navClass: ['owl-prev', 'owl-next'],
        navContainer : '.side-gallery-nav-carousel' ,
        dotsContainer : '.side-gallery-dots-carousel' ,
        rtl: _rtl,
        items:1,
    })

    // Sidebar articles Slider
    $('.side-articles-carousel').owlCarousel({
        loop:true,
        dots: true,
        nav:true,
        navText: ['<svg xmlns="http://www.w3.org/2000/svg" width="59.384" height="58.97" viewBox="0 0 59.384 58.97"><defs><style>.a{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:2px;}</style></defs><g transform="translate(-1193.936 -511.98)"><g transform="translate(1230.523 562.07) rotate(-135)"><path class="a" d="M39.735-.549-.549,39.734" transform="translate(0 -10.045)"/><path class="a" d="M28.9,28.664l-29.451.787L.238,0" transform="translate(0 0.238)"/></g></g></svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="59.384" height="58.97" viewBox="0 0 59.384 58.97"><defs><style>.a{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:2px;}</style></defs><g transform="translate(-1193.936 -511.98)"><g transform="translate(1230.523 562.07) rotate(-135)"><path class="a" d="M39.735-.549-.549,39.734" transform="translate(0 -10.045)"/><path class="a" d="M28.9,28.664l-29.451.787L.238,0" transform="translate(0 0.238)"/></g></g></svg>'],
        navClass: ['owl-prev', 'owl-next'],
        navContainer : '.side-articles-nav-carousel' ,
        dotsContainer : '.side-articles-dots-carousel' ,
        rtl: _rtl,
        items:1,
    })

    // Home Slider
    // $(".datepicker").datepicker()
    $('[data-toggle="datepicker"]').datepicker();

    //Buttons do not have an accessible name and owl-dot is a button -- this to improve speed of website
    $(".owl-carousel .owl-dots .owl-dot").attr('aria-label','owl-dot');

    // smooth scroll for table content
    $('.mce-toc [contenteditable]').attr('contenteditable', 'false')
    $('.post-page .mce-toc').removeClass('card')
    $(".post-page .mce-toc li > a").bind("click", function(e) {
        var target = $(this).attr("href");
        var headerHeight = $(".site-header").height() + 30 ;
        var scrollToPosition = $(target).offset().top - headerHeight;
        $('html').animate({ 'scrollTop': scrollToPosition }, 1000, function(target){
            window.location.hash = target;
        });
        e.preventDefault();
    })

    // // toolTip
    // $(function () {
    //     $('[data-toggle="tooltip"]').tooltip()
    // })

    // to just hide modal when click prev button in browser
    $('.modal').on('shown.bs.modal', function () {
        var urlReplace = '#' + $(this).attr('id')
        history.pushState(null, null, urlReplace)
    })

    $(window).on('popstate', function () {
        $('.modal').modal('hide')
    })
    // //-----------

    var  x = $('.old-phone-number').text()
    x = x.substr(0, 3) + " " + x[3] + " " + x.substr(4)
    $('.phone-number').text(x)

    //Buttons do not have an accessible name -- this to improve speed of website
    $(".owl-carousel .owl-dots .owl-dot").attr('aria-label','owl-dot')
    $(".dots-contain .owl-dot").attr('aria-label','owl-dot')
    $(".owl-carousel .owl-nav .owl-prev").attr('aria-label','owl-prev')
    $(".owl-carousel .owl-nav .owl-next").attr('aria-label','owl-next')
    $(".clients-nav-container .owl-dots .owl-dot").attr('aria-label','owl-dot')
    $('.clients-nav-container .owl-prev').attr('aria-label', 'owl-prev')
    $('.clients-nav-container .owl-next').attr('aria-label', 'owl-prev')
    $(".nav-dots .owl-dot").attr('aria-label','owl-dot')
    $('.nav-dots .owl-prev').attr('aria-label', 'owl-prev')
    $('.nav-dots .owl-next').attr('aria-label', 'owl-prev')
});
